import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate, useRouterState } from "@tanstack/react-router";
import { authMeQuery } from "@/api/queries";
import { UnauthorizedError } from "@/api/client";

/** Fetch current user. If 401, navigate to /login carrying the current
 * path as `next` so post-login redirect restores context. */
export function useAuth() {
  const navigate = useNavigate();
  const location = useRouterState({ select: (s) => s.location });
  const query = useQuery(authMeQuery());

  useEffect(() => {
    if (query.error instanceof UnauthorizedError) {
      // Stay on /login if we're already there.
      if (location.pathname !== "/login") {
        void navigate({
          to: "/login",
          search: { next: location.pathname + location.searchStr },
        });
      }
    }
  }, [query.error, navigate, location.pathname, location.searchStr]);

  return query;
}
